/* eslint-disable prettier/prettier */
export const HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD = import.meta.env.VITE_HUB_CONNECTOR_ENVIRONMENT === 'SWAGWORLD'
/* eslint-enable prettier/prettier */
